// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr       : false,
    mode: 'dev',
    // Configurador QR: escribir la red del lector (paso Red). Las claves no se probaron en un CR06E
    // y una mala lo deja fuera de la red. Apagado: este archivo es el del deploy de DEV (npm run
    // build no pasa configuracion) y DEV llega a lectores reales. Encendido solo en
    // environment.hmr.ts. Para probarlo con un CR06E, encenderlo aqui a proposito en local
    // (npm start; con hmr la app hoy no arranca, ver main.ts) sin commitearlo. Activar en
    // DEV/UAT/PRD solo tras probar en un CR06E: Ethernet fija, Wi-Fi DHCP, Wi-Fi fija y adaptativo.
    qrReaderNetworkConfig: false
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
